import {faCalendar} from '@fortawesome/free-solid-svg-icons';

export default [
    {
        to: "/admin/agenda",
        icon: faCalendar,
        title: "Agenda",
    }
];